import { i18n } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { APP_NAMESPACE, createI18n } from "@prostocheck/i18n";

import { APP_BUNDLES, LOCALE_STORAGE_KEY } from "./i18n.constants";

/**
 * Unlike the landing, the dashboard has no per-language URLs: it is a private
 * SPA behind a login, so the language is a user preference. A remembered choice
 * wins over the browser's, and `createI18n` falls back to Ukrainian for
 * anything we do not ship.
 */
export const appI18n: i18n = createI18n({
  bundles: APP_BUNDLES,
  defaultNS: APP_NAMESPACE,
  plugins: [LanguageDetector],
  options: {
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
    },
  },
});
